// extracted by mini-css-extract-plugin
export default {"main":"Nav_main__Afv5v","left":"Nav_left__eC8Md","name":"Nav_name__l7mag","right":"Nav_right__RUo2o","list":"Nav_list__hD05C"};